import React from "react"

interface DeleteRecordingIconProps {
    onClick: (ev: any) => void
}

export default class DeleteRecordingIcon extends React.Component<DeleteRecordingIconProps, {}> {
    render() {
        return (
            <div className={"DeleteRecordingIcon"}>
                <div
                    className={"DeleteRecordingIcon__icon"}
                    data-tst-id='delete-recording-icon'
                    onClick={this.props.onClick}
                    onKeyPress={this.props.onClick}
                    tabIndex={0}
                />
            </div>
        )
    }
}
